import * as actionType from "store/actions/actionTypes"
import DefaultToObject from "store/defaults/DefaultToObject"
import StoreTemplate from "store/StoreTemplate"

const container = DefaultToObject()

const defaultState = function () {
  return {
    collection: defaultPermissions(),
  }
}

const defaultPermissions = () => {
  return DefaultToObject()
}

const Permissions = StoreTemplate(defaultState(), container)

container[actionType.ACTION_PERMISSIONS_SET_DATA] = function (state, payload) {
  const collection = {}
  for (let index in payload.data){
    collection[`${payload.data[index].category}`] = payload.data[index]
  }
  state.collection = {
    ...collection
  }
  return {
    ...state,
  }
}

container[actionType.ACTION_PERMISSIONS_GLOBAL_RESET] = function (state) {
  return defaultPermissions()
}

export default Permissions
